import { useContext, useEffect } from "react";
import { Image } from "../../Image/Image";
import { transformDate } from "../../SearchSportsCamps/data";
import { SharePage } from "../../SharePage/SharePage";
import { ActivitiesContext } from "../context/activities-context";
import GetLocation from "./GetLocation";
import GetPrices from "./GetPrices";

const navigate = (url) => {
	if (window && window.location && window.location.pathname && window.location.pathname !== url) {
		window.history.pushState({}, '', url);
	}
};

const ActivityDetail = () => {
	const { moreInfoCard, setMoreInfoVisible, dictionaryWords } =
		useContext(ActivitiesContext);

	var url = window.location.protocol + "//" + window.location.host + window.location.pathname;

	const setIdUrl = () => {
		const fullId = moreInfoCard['@id'];
		const id = fullId.split("/").splice(-1);
		navigate(url + "activity/" + id)
	};

	useEffect(() => {
		if (!url.includes("activity")) {
			setIdUrl();
		}
	}, []);

	//Remopve query param from url
	const deleteActivity = () => {
		if (url.includes("activity")) {
			const newUrl = url.split("activity");
			navigate(newUrl[0]);
		}
		else {
			navigate(url);
		}
	}


	//Clear detailstate
	const hideSportActivityDetail = () => {
		setMoreInfoVisible((prevMoreInfoVisible) => !prevMoreInfoVisible);
	};

	const closeDetail = () => {
		hideSportActivityDetail();
		deleteActivity();
	}

	const stopPropagation = (e) => {
		e.stopPropagation();
	};

	return (
		<div className="c-dimmer" onClick={closeDetail}>
			<div className="c-detail-fiche-wrap">
				<div className="c-detail-fiche" onClick={stopPropagation}>
					<header className="c-detail-fiche__header">
						<div className="text">
							<div className="c-detail-fiche__close-button" onClick={closeDetail}>
								<i className="fa fa-close"></i>
							</div>
							<h2 className="title">
								{moreInfoCard.name && moreInfoCard.name.nl}
							</h2>
						</div>
					</header>
					<div className="c-detail-fiche__body">
						<div className="practical">
							<div className="left">
								<div className="inner">
									<div className="top">
										<div className="image">
											{moreInfoCard.image ? (
												<img
													className="image-component"
													alt={
														moreInfoCard.name.nl &&
														moreInfoCard.name.nl
													}
													src={moreInfoCard.image + "?width=300&height=0"}
												></img>
											) : (
												<img
													className="image-component"
													alt="no-image"
													src={"/images/placeholder.png"}
												></img>
											)}
										</div>
									</div>
									<div className="bottom">
										<div className="info">
											<p className="title">
												{dictionaryWords.when}
											</p>
											<div>
												<p>
													{transformDate(
														moreInfoCard.startDate
													) ===
														transformDate(
															moreInfoCard.endDate
														)
														? transformDate(
															moreInfoCard.startDate
														)
														: `${transformDate(
															moreInfoCard.startDate
														)} - ${transformDate(
															moreInfoCard.endDate
														)}`}
												</p>
											</div>
										</div>

										<GetLocation
											moreInfoCard={moreInfoCard}
										/>

										<div className="info">
											<p className="title">
												{dictionaryWords.price}
											</p>
											{moreInfoCard.priceInfo
												? moreInfoCard.priceInfo.map(
													(priceInfo) => (
														<GetPrices
															key={`${priceInfo.category} ${priceInfo.price}`}
															priceInfo={
																priceInfo
															}
														/>
													)
												)
												: dictionaryWords.noPrice}
										</div>
										<div className="info">
											<p className="title">
												{dictionaryWords.contactDetails}
											</p>
											{moreInfoCard.contactPoint && (
												<>
													<div>
														{moreInfoCard
															.contactPoint
															.url[0] && (
																<a
																	href={
																		moreInfoCard
																			.contactPoint
																			.url[0]
																	}
																	target="_blank"
																>
																	<i className="fa fa-external-link"></i>
																	<span>
																		{
																			moreInfoCard
																				.contactPoint
																				.url[0]
																		}
																	</span>
																</a>
															)}
													</div>
													<div>
														{moreInfoCard
															.contactPoint
															.email[0] && (
																<a
																	href={`mailto:${moreInfoCard.contactPoint.email[0]}`}
																>
																	<i className="fa fa-envelope"></i>
																	<span>
																		{
																			moreInfoCard
																				.contactPoint
																				.email[0]
																		}
																	</span>
																</a>
															)}
													</div>
													<div>
														{moreInfoCard
															.contactPoint
															.phone[0] && (
																<a
																	href={`tel:${moreInfoCard.contactPoint.phone[0]}`}
																>
																	<i className="fa fa-phone"></i>
																	<span>
																		{
																			moreInfoCard
																				.contactPoint
																				.phone[0]
																		}
																	</span>
																</a>
															)}
													</div>
												</>
											)}
										</div>
									</div>
								</div>
							</div>
							<div className="right">
								<div className="inner">
									{moreInfoCard.description &&
										moreInfoCard.description.nl && (
											<div className="long-descr">
												<div
													dangerouslySetInnerHTML={{
														__html: `${moreInfoCard.description.nl}`,
													}}
												/>
											</div>
										)}

									{moreInfoCard.terms && (
										<ul className="c-tag-list">
											{moreInfoCard.terms &&
												moreInfoCard.terms.map(
													(data) => {
														{
															return (
																<li
																	className="c-tag--label"
																	key={
																		data.id
																	}
																>
																	{data.label}
																</li>
															);
														}
													}
												)}
										</ul>
									)}
									<SharePage />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ActivityDetail;
